import styled from "@emotion/styled";

import { Display } from "scmp-app/components/search/search-result-panel/components/dropdown-menu/styles";

export const SortingMenuContainer = styled.div`
  ${Display} {
    color: #000000;
    font-weight: normal;
  }
`;
